module.exports = __webpack_public_path__ + "img/interaction-bar-search-chevy.2c22a5c2.png";